module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-1.eeb54308.PNG";